import axiosIns from '@/libs/axios'

const ROOT_URL = '/system-console'

export default {
  namespaced: true,
  state: {
    payload: {
      file: 'combined',
      path: 'logs/combined.log',
      lines: [],
      totalReturned: 0,
      exists: false,
      truncated: false,
      updatedAt: null,
    },
    loading: false,
    dataSave: {
      message: null,
      status: null,
    },
  },
  getters: {
    payload(state) { return state.payload },
    lines(state) { return state.payload.lines || [] },
    loading(state) { return state.loading },
    dataSaveStatus(state) { return state.dataSave },
  },
  mutations: {
    SET_PAYLOAD(state, payload) {
      state.payload = { ...state.payload, ...(payload || {}) }
    },
    SET_LOADING(state, val) { state.loading = val },
    SET_DATA_SAVE(state, data) { state.dataSave = data },
  },
  actions: {
    fetch({ commit }, params) {
      commit('SET_LOADING', true)
      return axiosIns.post(`${ROOT_URL}/logs`, params || {})
        .then(response => {
          commit('SET_PAYLOAD', response.data.data || {})
          commit('SET_DATA_SAVE', { status: null, message: null })
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Konsol logları alınamadı.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
        })
        .finally(() => commit('SET_LOADING', false))
    },
  },
}
